import React from "react";
import { Button } from "./ui/button";
import { Calendar, ArrowRight, Play } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-orange-50 via-yellow-50 to-red-50 min-h-screen flex items-center">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-32 w-80 h-80 bg-gradient-to-br from-orange-400/20 to-red-600/20 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-32 w-80 h-80 bg-gradient-to-tr from-yellow-400/20 to-orange-600/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="inline-flex items-center px-4 py-2 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">
                🚀 Transform Your Cafe Digitally
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                From Normal Cafe to{" "}
                <span className="bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
                  Dream Cafe
                </span>
              </h1>
              <p className="text-xl md:text-2xl text-gray-600 max-w-2xl leading-relaxed">
                QR-based digital menus, integrated payments, and smart
                analytics. Make your cafe tech-savvy and boost profits by 40%.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => {
                  const section = document.getElementById("demo");
                  if (section) {
                    section.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  } else {
                    console.warn("Section with id='demo' not found");
                  }
                }}
                size="lg"
                className="bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white px-8 py-4 text-lg font-semibold group transition-all duration-300 transform hover:scale-105"
              >
                <Calendar className="mr-2 h-5 w-5" />
                Book Free Demo
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
<a
  href="https://www.youtube.com/watch?v=Vm-Z7wf4m3U"
  target="_blank"
  rel="noopener noreferrer"
>
  <Button
    variant="outline"
    size="lg"
    className="border-2 border-orange-300 text-orange-700 hover:bg-orange-50 px-8 py-4 text-lg font-semibold transition-all duration-300 group"
  >
    <Play className="mr-2 h-5 w-5" />
    Watch Demo
  </Button>
</a>
            </div>

            {/* <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-2xl font-bold text-orange-600">₹599</div>
                <div className="text-sm text-gray-600">Starting from/month</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-orange-600">40%</div>
                <div className="text-sm text-gray-600">Profit increase</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-orange-600">100+</div>
                <div className="text-sm text-gray-600">Happy cafes</div>
              </div>
            </div> */}
          </div>

          {/* Right Content - Hero Image */}
          <div className="relative">
            <div className="relative">
              <img
                src="./QRHero.webp"
                alt="QR code menu on restaurant table"
                className="w-full max-w-lg mx-auto rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-300"
              />
            </div>

            {/* Floating elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-orange-400 to-red-600 rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-600 rounded-full opacity-30 animate-bounce"></div>

            {/* Floating stats */}
            <div className="absolute top-8 -left-4 bg-white rounded-2xl shadow-lg p-4 animate-float">
              <div className="text-sm text-gray-600">Orders Today</div>
              <div className="text-2xl font-bold text-orange-600">247</div>
            </div>

            <div className="absolute bottom-8 -right-4 bg-white rounded-2xl shadow-lg p-4 animate-float-delayed">
              <div className="text-sm text-gray-600">Revenue</div>
              <div className="text-2xl font-bold text-green-600">₹24,750</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
